/**
 * Pin icon based on a simple outline push-pin silhouette.
 * Uses currentColor for both stroke and optional fill.
 */
export function Pin({ className, width = '1em', height = '1em', pinned = false, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={pinned ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...rest}
    >
      <path d="M8 3.5h8" />
      <path d="M9 3.5v4.2l-2.7 3.1v1.3h11.4v-1.3L15 7.7V3.5" />
      <path d="M12 12.1v8.4" />
    </svg>
  )
}
